module.exports = __webpack_public_path__ + "static/media/lucieGuibault.aba90608.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/lucieGuibault.jpg
// module id = 1578
// module chunks = 1